module.exports = require('./upper-case');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/string/uc.js
// module id = 284
// module chunks = 0 1 2